<template>
    <templateList
        page-name="Lista de Reservas"
        search-event="sales-reservations-search-options"
        add-event="sales-reservations-add"
        filters-apply-event="filter-list-reservations"
        add-button-text="Adicionar Reserva"
        clear-filters-event="clear-filters-list-reservations"
        search-input-placeholder="Pesquise também por Quadra/Lote"
        menu-card-icon="fal fa-cog"
        @input="loadFilters"
    >
        <template #bradcrumbs>
            <ui-breadcrumbs design="full" :container="false">
                <template #left> Vendas &#8226; Reservas </template>
            </ui-breadcrumbs>
        </template>

		<template #viewOptions>
            <div v-if="totalItens > 0" class="selected-reserves">
                <span  class="selected-reserves-text">
                    Você selecionou <span class="selected-reserves-count">{{ totalItens }}</span> reservas.
                </span>
				<div class="select-container">
					<ui-select-v2
						:data="selectMassAction"
						return-value="valueSelect"
						:placeholder="'Selecione uma ação'"
						:search="false"
						:showFooter="false"
						size="lg"
						@input="handleMassAction"
						v-model="valueSelect"
						:margin-botton="false"
					/>
				</div>
            </div>
        </template>

        <template #content>
            <ui-data-table
                :per-page="50"
                :columns="tableColumns"
                :filters="tableFiltersComputed"
                :sort-by="{ value: 'id_reserve', dir: 'desc' }"
                :control-fixed="true"
                :borders="true"
				:show-checkbox-table="chekcBoxPermission"
                :zebra="true"
                :is-fixed-list="true"
                name="dashboard-reservations-list"
                service="reserve"
                search-event="sales-reservations-search"
                tr-component="sales/reservations/table-line"
                not-found-icon="fal fa-user"
                not-found-text="Não foi possível encontrar nenhuma Reserva"
				@checked-itens="handleCheckedItens"
            />
            <ui-renew-time-modal name="sales-reservations-renew-time" />
            <ui-sold-modal name="sales-reservations-sold" />
            <ui-cancel-modal name="sales-reservations-cancel" />
            <ui-queue-modal />
            <ui-modal-message
                service="reserve"
                :above-all="true"
                name="update-reserve"
                title="Deseja realmente efetuar a venda?"
                text="Cuidado, esta ação não poderá ser desfeita."
                btn-type="danger"
                btn-text="Confirmar"
            />
			<change-stage-status-modal
				icon="ui-allotment-icon"
				:firstTitle="firstTitle"
				:secondTitle="secondTitle"
				:modalTextAlert="modalTextAlert"
				:buttonText="'Avançar'"
				:closeModalAction="clearSelect"
				:filteredAction="computedActions"
				@selected-action="handleSelectedAction"
				:buttonAction="openConfirmModal"
			/>
			<code-confirm-modal
				:titleConfirmModal="titleConfirmModal"
				:secundaryTitleConfirmModal="secundaryTitleConfirmModal"
				:modalAlert="alertTextConfirmModal"
				:textConfirmButton="buttonTextConfirmModal"
				:onConfirm="cancelMultiplesReserves"
				icon="ui-allotment-icon"
				:closeModalAction="clearSelect"
			/>
			<progress-bar-modal
				icon="ui-allotment-icon"
				:titleProgressModal="titleProgressModalComputed"
				:titleSuccess="titleSuccessModal"
				:modalAlert="alertTextProgressModal"
				:progressValue="processedItens"
				:totalValue="totalItens"
				:handleError="handleErrorProcess"
				:isPaused.sync="isPaused"
            	@update:paused="handlePause"
				@modal-closed-parent="resetProcess"
				:isSuccessfull="handleSuccessfull"
				:blockPauseButton="blockPauseHandler"
			/>
        </template>

        <template #filters>
            <form>
                <div v-for="(filter, index) in filtersComputed" :key="index">
                    <!-- Componentes de data -->
                    <ui-date-range
                        v-if="filter.component === 'datepicker-range'"
                        v-model="filter.params.value"
                        size="md"
                        :label="filter.label"
                    />

                    <!-- Componentes de selecao -->
                    <ui-select-v2
                        v-else-if="filter.component === 'select-tags'"
                        v-model="filter.params.value"
                        size="md"
                        :data="filter.options"
                        :label="filter.label"
                        :item-label="filter.itemLabel"
                        :search="filter.searchAble"
                        :multiple="filter.multiple"
                        :return-value="filter.returnValue"
                        @input="call(filter.handler, $event)"
                    />
                </div>
            </form>
        </template>
    </templateList>
</template>

<script>
import { uiBreadcrumbs, uiDataTable, uiLoadIndicator } from '@/components/ui'
import changeStageStatusModal from '@/components/ui-facilita/change-stage-status-modal'
import codeConfirmModal from '@/components/ui-facilita/code-confirm-modal'
import ProgressBarModal from '@/components/ui-facilita/progress-bar-modal'
import { uiButton } from '@/components/ui/buttons'
import { uiDateRange, uiSelectV2 } from '@/components/ui/form'
import { uiModalMessage } from '@/components/ui/modal'
import uiCancelModal from './components/cancel-modal'
import uiQueueModal from './components/queue-modal'
import uiRenewTimeModal from './components/renew-time-modal'
import uiSoldModal from './components/sold-modal'

import templateList from '@/templates/page-list'

import { action, reserve, reserves } from '@/services/axios'

import { mapGetters } from 'vuex'

import { helpersMixin, permissionsMixin, utilMixin } from '@/mixins'

export default {
	name: 'listar-reservas',
	components: {
		templateList,
		uiBreadcrumbs,
		uiDataTable,
		uiDateRange,
		uiRenewTimeModal,
		uiSoldModal,
		uiCancelModal,
		uiQueueModal,
		uiModalMessage,
		uiSelectV2,
		uiButton,
		uiLoadIndicator,
		ProgressBarModal,
		codeConfirmModal,
		changeStageStatusModal,
	},

	mixins: [helpersMixin, utilMixin, permissionsMixin],

	data() {
		return {
			permissionMassAction: false,
			layout: {
				showFiltersMenu: false,
			},
			filters: [
				{
					params: {
						name: 'units.block',
						value: null,
					},
				},
				{
					params: {
						name: 'units.number',
						value: null,
					},
				},
				{
					component: 'datepicker-range',
					label: 'Período',
					disabled: false,
					hidden: false,
					style: 'col -right form-sale-dates',
					dateStart: '01/01/2012',
					params: {
						name: 'reserve_created_at',
						value: null,
					},
				},
				{
					component: 'select-tags',
					label: 'Status',
					disabled: false,
					hidden: false,
					method: 'readFilters',
					itemLabel: 'item',
					searchAble: false,
					multiple: true,
					options: [
						{ item: 'Vendido', name: 'sold', id: 0 },
						{ item: 'Cancelado', name: 'canceled', id: 1 },
						{ item: 'Em análise', name: 'waiting', id: 2 },
						{ item: 'Reservado', name: 'reserved', id: 3 },
					],
					params: {
						name: 'status_reserve',
						value: [],
					},
					returnValue: 'name',
				},
				{
					component: 'select-tags',
					label: 'Empreendimentos',
					disabled: false,
					hidden: false,
					itemLabel: 'label',
					searchAble: true,
					multiple: true,
					service: 'product',
					method: 'getHasReserve',
					options: [],
					params: {
						name: 'units.availability.product.name',
						value: [],
					},
					returnValue: 'id',
				},
			],
			tableColumns: [
				{
					title: 'Código',
					class: 'control-s',
					data: 'id_reserve',
					sortable: true,
				},
				{
					title: 'Data Solicitação',
					data: 'reserve_created_at',
					sortable: true,
				},
				{
					title: 'Solicitado por',
					data: 'requestered_user_name',
					sortable: true,
				},
				{
					title: 'Gerenciado por',
					data: 'managed_user_name',
					sortable: true,
				},
				{
					title: 'Negócio',
				},
				{
					title: 'Responsável pelo Negócio',
					data: 'reserved.first_name',
					sortable: true,
				},
				{
					title: 'Empreendimento',
					data: 'units.availability.product.name',
					sortable: false,
				},
				{
					title: 'Unidade',
				},
				{
					title: 'Etapa / Status',
					data: 'funnel_stage_name',
					sortable: true
				},
				{
					title: 'Status da Reserva',
					data: 'status_reserve',
					sortable: true,
				},
				{
					title: 'Expira em:',
					data: 'order_reservation_expiration_date',
					sortable: true,
				},
				{
					title: 'Corretor',
				},
				{
					title: 'Equipe',
				},
				{
					title: 'Gerente',
				},
				{
					title: 'Fila de Espera',
				},
				{
					title: '',
					class: 'control-xs',
				},
			],
			selectMassAction: [
				{
					label:'Cancelar reservas',
					valueSelect: 'cancel-reserves'
				}
			],
			titleConfirmModal: '',
			secundaryTitleConfirmModal: '',
			alertTextConfirmModal: '',
			buttonTextConfirmModal: '',
			titleProgressModal: '',
			alertTextProgressModal: '',
			titleSuccessModal: '',
			firstTitle: '',
			secondTitle: '',
			modalTextAlert: '',
			checkedItens: 0,
			valueSelect: null,
			processedItens: 0,
			totalItens: 0,
			isPaused: false,
			handleErrorProcess: false,
			shouldStopProcess: false,
			successfullCount: 0,
			handleSuccessfull: false,
			chekcBoxPermission: false,
			allActions: [],
			selectedActionId: null,
			blockPauseHandler: false
		}
	},
	computed: {
		...mapGetters('auth', {
			user: 'getUser',
		}),

		/**
		 * Filtra e processa os filtros disponíveis de acordo com regras específicas para cada filtro
		 */
		filtersComputed() {
			return this.filters.map((filter) => {
				/** Verifica se o filtro possui um handler e se seu valor já foi definido no pré-processamento */
				if (filter.handler && filter.params.value)
					this.call(filter.handler, filter.params.value)

				return filter
			})
		},
		/**
		 * Computed property que retorna os dados dos filtros a serem passados
		 * para o datatable
		 */
		tableFiltersComputed() {
			return this.filters.map((filter) => {
				let params = { ...filter.params }

				if (filter.params.name === 'status_reserve') {
					params.value = Array.isArray(filter.params.value)
						? filter.params.value.join(',')
						: filter.params.value
				}

				if (filter.params.name === 'units.availability.product.name') {
					params.value = Array.isArray(filter.params.value)
						? filter.params.value.join(',')
						: filter.params.value
				}
				return params
			})
		},
		titleProgressModalComputed() {
			return `Cancelando ${this.processedItens} de ${this.totalItens} reservas.`;
		},
		computedActions(){
			return this.allActions.filter(action => action.action === "cancel_reserve");
		}
	},

	mounted() {
		this.getConfigs()
		this.getAllActions();
		/** Redireciona para o guia de cadastro de negócios/clientes do painel Legado */
		this.$root.$on('sales-reservations-add', () => {
			/**
			 * Emite o evento do Google Analytics
			 */
			this.$gtm.trackEvent({
				event: 'fac_button_click',
				category: 'vuejs-criar reserva',
				action: 'click',
				label: 'Criar reserva a partir da lista de reservas',
			})

			this.$root.$emit('modal-open-global--request-reserve')
		})

		/** Realiza uma listagem aplicando os filtros necessários */
		this.$root.$on('filter-list-reservations', () => {
			this.$root.$emit('sales-reservations-search')
		})

		/** Trata o evento que limpa os filtros e refaz a listagem */
		this.$root.$on('clear-filters-list-reservations', async () => {
			await this.resetFilters()
			this.$root.$emit('clear-all-dates')
			this.$root.$emit('sales-reservations-search')
		})

		this.$root.$on('modal-msg-update-reserve-response', () => {
			this.$root.$emit('sales-reservations-search')
		})

		this.$root.$on('sales-reservations-search-options', (search) => {
			/**
			 * Limpa os parametros para não impedir o funcionamento da funcao padrao
			 */
			for (const item in this.filters) {
				if (this.filters[item].params.name === 'units.block')
					this.filters[item].params.value = null
				if (this.filters[item].params.name === 'units.number')
					this.filters[item].params.value = null
			}

			/**
			 * Veririca se existe a / para buscar por lote/quadra
			 */
			if (search.includes('/')) {
				let data = search.split('/')
				this.filters[0].params.value = `^${data[0]}$`
				this.filters[1].params.value = `^${data[1]}$`

				/**
				 * Insere um timeout para dar tempo para que a prop de filtros do DataTable seja atualizada.
				 * Obs.: No momento é a solução que menos impacta os components. Recomenda-se trocar os filtros
				 * para o Vuex no futuro.
				 */
				setTimeout(() => {
					this.$root.$emit('sales-reservations-search', '')
				}, 250)
			} else {
				/**
				 * Insere um timeout para dar tempo para que a prop de filtros do DataTable seja atualizada.
				 * Obs.: No momento é a solução que menos impacta os components. Recomenda-se trocar os filtros
				 * para o Vuex no futuro.
				 */
				setTimeout(() => {
					this.$root.$emit('sales-reservations-search', search)
				}, 250)
			}
		})
		this.$root.$on('modal-msg-close-progress-bar-modal', () => {
			this.resetProcess();
		});
	},

	beforeDestroy() {
		this.$root.$off('sales-reservations-add')
		this.$root.$off('filter-list-reservations')
		this.$root.$off('clear-filters-list-reservations')
		this.$root.$off('modal-msg-update-reserve-response')
		this.$root.$off('sales-reservations-search-options')
		this.$root.$off('modal-msg-close-code-confirm-modal', this.clearSelect());
		this.$root.$off('modal-msg-close-progress-bar-modal', this.clearSelect());
	},

	methods: {
		/**
		 * Chama dinamicamente um handler para tratar o evento do filtro
		 */
		call(handler, event) {
			if (handler) this[handler](event)
		},

		resetFilters() {
			for (const filter of this.filters) {
				if (filter.component === 'select-tags') {
					filter.params.value = []
				}

				if (filter.component === 'datepicker-range') {
					filter.params.value = ''
				}

				if (!filter.component) {
					filter.params.value = null
				}
			}
		},
		loadFilters(filters) {
			let hasFilter = filters ? filters.filter(res => this.$mx_hasValue(res.value)) : null

			for (const filter of this.filters) {
				if (filters && hasFilter.length > 0) {
					filter.params = filters.find(({ name }) => name == filter.params.name)
				}

				if (filter.params.name == "status_reserve" && (!hasFilter || hasFilter.length == 0)) {
					filter.params.value = ["reserved"]
				}

				if (filter.service) {
					(() => import('@/services/axios/modules/'+ filter.service + '.js'))().then(service => {
						const api = service.default.build()
						let params = filter.serviceParams ? [...filter.serviceParams] : ['']
						api[filter.method](...params).then((response) => {
							let data = []
							/** Verifica se a requisição retornou uma paginação */
							if (Object.prototype.hasOwnProperty.call(response.data, 'total')) {
								data = [...response.data.data]

							/** Verifica se a requisição retornou um array */
							} else if (Object.prototype.hasOwnProperty.call(response.data, 'length')) {
								data = [...response.data]

							/** Se nenhum dos outros casos for atendido, trata o retorno como um objeto */
							} else if (typeof response.data === 'object') {
								data = { ...response.data }
							}

							/** Verifica se os resultados necessitam ser formatados */
							filter.options = filter.parse ? filter.parse(data) : Object.values(data)
						})
						.catch(() => {})
					})
					.catch(() => {})
				}
			}
		},

		async getConfigs(){
			await reserves.getConfigGlobal()
			.then(({data}) => {
				if(data.data.global_reserves_bulk_cancel.active === true && this.$mx_userIsAdmin){
					this.chekcBoxPermission = true
				}
			})
		},

		clearSelect(){
			this.valueSelect = null;
		},
		handleCheckedItens(itens){
			this.checkedItens = itens;
			this.totalItens = itens.length;
		},
		handleMassAction(){
			const hasCancelReserve = this.allActions.some(action => action.action === 'cancel_reserve');
			if(this.valueSelect && hasCancelReserve){
				this.modalContent();
				this.$root.$emit('modal-msg-open-change-stage-status-modal');
			}
			if(this.valueSelect && !hasCancelReserve){
				this.modalButtonText = this.selectMassAction.find(action => action.valueSelect === this.valueSelect)?.label || '';

				this.modalContent();

				this.$root.$emit('modal-msg-open-code-confirm-modal');
			}
		},

		async getAllActions() {
			await action.getAllV2('',{
				groupby: 'funnel_stage_id,funnel_stage_status_id,id',
				orderby: 'funnel_stage_status_id'
			})
			.then((actionResponse) => {
				if(actionResponse.data.status === 'success'){
					this.allActions = actionResponse.data.data
				}
			})
			.catch((error) => {
				console.error(error)
			})
		},

		async cancelMultiplesReserves(){
			this.clearSelect()
			this.$root.$emit('modal-msg-close-code-confirm-modal');
			this.$root.$emit('modal-msg-open-progress-bar-modal');

			for(let i = this.processedItens; i < this.totalItens; i++){
				if (this.shouldStopProcess) {
					break; // Sai do loop
				}

				if(this.isPaused){
					await this.waitForResume();
				}

				if (this.totalItens === 0) {
					return;
				}
				const reservedItem = this.checkedItens[i];
				const requestData = {
					id: reservedItem.id_reserve,
					expire_time: '00:00:00',
					reason: 'Cancelamento em massa',
					status: 'canceled'
				}

				this.processedItens++;

				if(this.processedItens === this.totalItens){
					this.blockPauseHandler = true
				}

				await reserve.updateV2('', requestData.id, {...requestData, action_id: this.selectedActionId})
				.then((response) => {
					if(response.data.status === 'success'){
						this.successfullCount++
						this.handleErrorProcess = false;
					}
				})
				.catch(() => {
					this.handleErrorProcess = true;
					this.shouldStopProcess = true;
				})
			}
			if(this.successfullCount === this.totalItens && !this.handleErrorProcess ){
				this.handleSuccessfull = true;
			}
			if(this.handleErrorProcess){
				this.clearSelect();
				this.checkedItens = [];
				this.totalItens = 0;
				this.processedItens = 0;
				this.isPaused = false;
			}
		},
		async waitForResume() {
			return new Promise(resolve => {
				const checkInterval = setInterval(() => {
					if (!this.isPaused) { // Apenas continua quando o usuário clicar no botão
						clearInterval(checkInterval);
						resolve();
					}
				}, 50);
			});
		},

		handlePause(paused){
			this.isPaused = paused;
		},
		resetProcess() {
			this.clearSelect();
			setTimeout(() => {
				this.checkedItens = [];
				this.totalItens = 0;
				this.processedItens = 0;
				this.successfullCount = 0;
				this.isPaused = false;
				this.blockPauseHandler = false
				this.handleErrorProcess = false;
				this.shouldStopProcess = false;
				this.handleSuccessfull = false;
			}, 100)
			this.$root.$emit('sales-reservations-search');
		},

		handleSelectedAction(actionId){
			this.selectedActionId = actionId || null;
		},

		modalContent(){
			if(this.valueSelect === 'cancel-reserves'){
				this.titleConfirmModal = 'Tem certeza que seja cancelar as';
				this.secundaryTitleConfirmModal = `${this.totalItens} reservas?`;
				this.alertTextConfirmModal = 'Essa ação não poderá ser desfeita.';
				this.buttonTextConfirmModal= 'Cancelar Reservas';
				this.titleSuccessModal = 'Cancelamento de reservas'
				this.titleProgressModal = `Cancelando ${this.processedItens} de ${this.totalItens} reservas.`;
				this.alertTextProgressModal = 'Essa ação não poderá ser desfeita.';

				this.firstTitle = 'Tem certeza que seja cancelar as ';
				this.secondTitle = `${this.totalItens} reservas?`;
				this.modalTextAlert = 'Deseja alterar a etapa e status dos negócios vinculados?';
			}
		},
		openConfirmModal(){
			this.$root.$emit('modal-msg-close-change-stage-status-modal');
			this.$root.$emit('modal-msg-open-code-confirm-modal');
		}

	},
}
</script>

<style lang="stylus" scoped>
@import 'styles.styl';
</style>